<template>
  <Container>
    <vueper-slides
      :bullets="false"
      :class="['no-shadow', $style.slideContainer]"
      :disableArrowsOnEdges="false"
      fixedHeight
      :touchable="false"
    >
      <template #arrow-left>
        <div
          :class="$style.leftArrow"
        >
          <ArrowLeft
            :class="$style.arrow"
          />
        </div>
      </template>
      <template #arrow-right>
        <div
          :class="$style.rightArrow"
        >
          <ArrowRight
            :class="$style.arrow"
          />
        </div>
      </template>
      <vueper-slide
        v-for="card in cards"
        :key="card.title"
        @mouseleave.native="hoveringCard = false"
        @mouseover.native="hoveringCard = true"
      >
        <template v-slot:content>
          <Card :class="$style.card">
            <PremiumFeatureFlag
              feature="osPatchManagement"
            />
            <HeadingMedium>
              {{ card.title }}
            </HeadingMedium>
            <ParagraphBody
              :class="$style.description"
            >
              {{ card.description }}
            </ParagraphBody>
            <hr>
            <img
              :class="$style.ospGraphic"
              :src="card.image"
              svg-inline
            >
            <div :class="$style.actionsContainer">
              <Button
                v-if="card.secondaryBtn"
                hasOutline
                :text="card.secondaryBtn"
                type="secondary"
                @click="redirectToPolicyGroups"
              />
              <Button
                v-if="card.primaryBtn"
                primary
                :text="card.primaryBtn"
                @click="redirectToPatchMgmt(card.primaryBtn)"
              />
            </div>
          </Card>
        </template>
      </vueper-slide>
    </vueper-slides>
  </Container>
</template>
<script>
import 'vueperslides/dist/vueperslides.css';
import {
  Button,
  Container,
  HeadingMedium,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import {
  GettingStartedRootLink,
  ItemTypeConsts,
  ItemTypeRoutes,
} from 'client/util/Constants';
import { VueperSlide, VueperSlides } from 'vueperslides';
import { trialFeatures } from 'client/util/Constants/FeatureTrialConstants';
import ArrowLeft from 'public/img/growth/arrow-left.svg?inline';
import ArrowRight from 'public/img/growth/arrow-right.svg?inline';
import Card from 'components/Card.vue';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';
import PremiumFeatureFlag from 'components/Badges/PremiumFeatureFlag.vue';
import Util from 'client/util/Util';

const kbLink = KbArticleUrls.patchManagementGettingStarted;
const browserPatchMgmtRouteName = ItemTypeRoutes[ItemTypeConsts.browserPatchManagement];
const osPatchMgmtRouteName = ItemTypeRoutes[ItemTypeConsts.osPatchManagement];
const policyGroupsRouteName = ItemTypeRoutes[ItemTypeConsts.configurationGroup];

export default {
  name: 'OsPatchPoliciesCard',

  components: {
    ArrowLeft,
    ArrowRight,
    Button,
    Card,
    Container,
    HeadingMedium,
    ParagraphBody,
    PremiumFeatureFlag,
    VueperSlides,
    VueperSlide,
  },

  trialFeatures,

  data: () => ({
    linkUrl: kbLink,
    hoveringCard: false,
  }),

  computed: {
    cards() {
      return [
        {
          id: 1,
          title: 'Manage OS Patch Policies & Policy Groups',
          description: 'JumpCloud\'s automated patch management helps you secure your fleet to remotely manage, schedule, and install OS updates for your macOS, Windows, and Ubuntu devices.',
          image: '/img/osp-computer-groups-badge.svg',
          primaryBtn: 'OS Patch Policies',
          secondaryBtn: 'Policy Groups',
        },
        {
          id: 2,
          title: 'Browser Patch Policies',
          description: 'Keep Google Chrome up to date for macOS, Windows, and Linux. Load preconfigured default Chrome browser patch policies to schedule how and when you enforce Chrome security patches.',
          image: `${GettingStartedRootLink.url}/getting-started-bpm-empty-graphic.svg`,
          primaryBtn: 'View Browser Patch Policies',
        },
      ];
    },
  },

  methods: {
    redirectToPatchMgmt(isBrowserPatchMgmt) {
      if (isBrowserPatchMgmt.includes('Browser')) {
        Util.redirect(browserPatchMgmtRouteName);
      } else {
        Util.redirect(osPatchMgmtRouteName);
      }
    },
    redirectToPolicyGroups() {
      Util.redirect(policyGroupsRouteName);
    },
  },
};
</script>
<style module>
.actionsContainer {
  align-items: center;
  display: flex;
  justify-content: space-around;
}

.slideContainer {
  min-height: 480px;
}

.slideContainer,
.card {
  height: 100%;
}

.leftArrow,
.rightArrow {
  align-content: center;
  align-items: center;
  display: flex;
  margin: 0 -1rem;
}

.leftArrow {
  left: 0;
}

.rightArrow {
  right: 0;
}

.slideContainer .arrow {
  margin: 0 auto;
  overflow: unset;
  padding: 0;
  stroke: none;
}

:global(.vueperslides__arrow) .disableArrow {
  display: none;
}

.description {
  color: var(--jcGrey600);
}

.ospGraphic {
  display: block;
  height: 14rem;
  margin: 1.5rem auto;
}

.premiumTitle {
  align-items: center;
  display: flex;
  margin-bottom: 0.6rem;
}

@media (min-width: 106rem) {
  .slideContainer {
    min-height: 455px;
  }
}
</style>
